import "../../components/PickupLocations.css";
import PickupLocationList from "../../components/PickupLocationList";
import PickupMap from "../../components/PickupMap";
import { useContext } from "react";
import { PickupLocationContext } from "../../store/PickupLocationContext";
import { ModalContext } from "../../store/ModalContext";
import { PickupLocationModalBody } from "./modals/PickupLocationModalBody";
import { SeasonContext } from "../../store/SeasonContext";
import { ApplicationPeriod } from "../../../../api/season";
//TODO should not depend on season
const PickupLocationsPage = () => {
  const { pickupLocations } = useContext(PickupLocationContext);
  const { openModal, closeModal } = useContext(ModalContext);
  const { areWeInSeason, applicationPeriod } = useContext(SeasonContext);

  function openPickupLocationModal(idToEdit: string) {
    if (
      areWeInSeason ||
      applicationPeriod !== ApplicationPeriod.ApplicationClosed
    ) {
      return;
    }
    const pickup = pickupLocations.find((p) => p._id === idToEdit);
    openModal({
      title: idToEdit
        ? `Edit ${pickup?.name ?? "pickup location"}`
        : "Create Pickup Location",
      body: (
        <PickupLocationModalBody idToEdit={idToEdit} onClose={closeModal} />
      ),
    });
  }

  return (
    <div className="page-container">
      <h1>Pickup Locations</h1>
      <div className="btn-aligned-right-box">
        <button
          className={
            areWeInSeason ||
            applicationPeriod !== ApplicationPeriod.ApplicationClosed
              ? "btn disabled-btn"
              : "btn "
          }
          onClick={() => {
            openPickupLocationModal("");
          }}
          disabled={
            areWeInSeason ||
            applicationPeriod !== ApplicationPeriod.ApplicationClosed
          }
        >
          Add Pickup Location
        </button>
      </div>
      <div className="page-content pickup-locations-page-content">
        <PickupLocationList
          onEdit={(id) => {
            openPickupLocationModal(id);
          }}
        />
        <PickupMap locations={pickupLocations} />
      </div>
    </div>
  );
};

export default PickupLocationsPage;
